import { REQUEST_URL } from "../constants";
import { PaginationQueryModel, BranchInputModel, CountryInputModel } from "../models";
import { RequestUtil, RequestFileUtil } from "../utils";

export const NetWorkService = {
  getAllBranchByCountry,
  getBranchDetail,
  createBranch,
  updateBranch,
  deleteBranch,
  getAllCountry,
  createCountry,
  uploadImageCountry,
  deleteCountry
};

function getAllBranchByCountry(query: { countryId: string } & PaginationQueryModel & { searchValue?: string } = { countryId: "" }) {
  const url = REQUEST_URL.GET_ALL_BRANCH_BY_COUNTRY;

  return RequestUtil.get({ url, query: query });
}

function getBranchDetail(branchId: string) {
  const url = REQUEST_URL.GET_BRANCH_DETAIL.replace("{BRANCH_ID}", branchId);

  return RequestUtil.get({ url });
}

function createBranch(data: BranchInputModel) {
  const url = REQUEST_URL.CREATE_BRANCH;

  return RequestUtil.post({ url, data });
}

function updateBranch(branchId: string, data: BranchInputModel) {
  const url = REQUEST_URL.UPDATE_BRANCH.replace("{BRANCH_ID}", branchId);

  return RequestUtil.put({ url, data });
}

function deleteBranch(branchId: string) {
  const url = REQUEST_URL.DELETE_BRANCH.replace("{BRANCH_ID}", branchId);

  return RequestUtil.delete({ url });
}

function getAllCountry() {
  const url = REQUEST_URL.GET_ALL_COUNTRY;

  return RequestUtil.get({ url });
}

function createCountry(data: CountryInputModel) {
  const url = REQUEST_URL.CREATE_COUNTRY;

  return RequestUtil.post({ url, data });
}

async function uploadImageCountry(formData: FormData) {
  const url = REQUEST_URL.IMAGE.UPLOAD_COUNTRY;

  return RequestFileUtil.post({ url, data: formData });
}

function deleteCountry(branchId: string) {
  const url = REQUEST_URL.DELETE_COUNTRY.replace("{COUNTRY_ID}", branchId);

  return RequestUtil.delete({ url });
}